import React from "react";
import { useAuth, ROLES, ROLE_LABELS } from "../context/AuthContext";

const Header = () => {
  const { user } = useAuth();

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case ROLES.SUPER_ADMIN:
        return "badge badge-danger";
      case ROLES.SUB_ADMIN:
        return "badge badge-primary";
      default:
        return "badge badge-light";
    }
  };

  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          {user?.role && (
            <li className="nav-item d-flex align-items-center">
              <span className={`${getRoleBadgeClass(user.role)} px-3 py-2`} style={{ fontSize: "0.9rem" }}>
                {ROLE_LABELS[user.role] || user.role?.replace("_", " ").toUpperCase()}
              </span>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default Header;
